import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import Subnav from './components/subnav/Entrypoint';
import SaSlider from './components/saSlider/Entrypoint';
import CookieNotice from './components/cookieNotice/EntryPoint';
import Visualizer from './components/boxVisualizer/Entrypoint';
import StoreLocator from './components/storeLocator/Entrypoint';
import Graph from './components/bnrGraph/Entrypoint';
import GraphV2 from './components/bnrGraphV2/Entrypoint';
import GraphV3 from './components/bnrGraphV3/Entrypoint';
import GraphV4 from './components/bnrGraphV4/Entrypoint';
import GraphV5 from './components/bnrGraphV5/Entrypoint';
import GraphV6 from './components/bnrGraphV6/Entrypoint';
import i18next from 'i18next';
import CustomSelect from './components/customSelect/CustomSelect';
import './i18n';

var subdomain = window.location.host.split('.')[1]
  ? window.location.host.split('.')[0]
  : false;

i18next.changeLanguage(subdomain ? subdomain : 'en', (err, t) => {
  if (err) return console.log('something went wrong loading', err);
});

if (document.querySelector('#js-subnav-root'))
  ReactDOM.render(<Subnav />, document.getElementById('js-subnav-root'));
if (document.querySelector('#contribute-slider-root'))
  ReactDOM.render(<SaSlider />, document.getElementById('contribute--root'));
if (document.querySelector('#js-bnr-graph-root'))
  ReactDOM.render(<Graph />, document.getElementById('js-bnr-graph-root'));
if (document.querySelector('#js-bnr-graphv2-root'))
  ReactDOM.render(<GraphV2 />, document.getElementById('js-bnr-graphv2-root'));
if (document.querySelector('#js-bnr-graphv3-root'))
  ReactDOM.render(<GraphV3 />, document.getElementById('js-bnr-graphv3-root'));
if (document.querySelector('#js-bnr-graphv4-root'))
  ReactDOM.render(<GraphV4 />, document.getElementById('js-bnr-graphv4-root'));
if (document.querySelector('#js-bnr-graphv5-root'))
  ReactDOM.render(<GraphV5 />, document.getElementById('js-bnr-graphv5-root'));
if (document.querySelector('#js-bnr-graphv6-root'))
  ReactDOM.render(<GraphV6 />, document.getElementById('js-bnr-graphv6-root'));

// if (!document.getElementById('cookie-notice')) {
//   const cookieDiv = document.createElement('div');
//   cookieDiv.id = 'cookie-notice';
//   document.body.appendChild(cookieDiv);
// }
// ReactDOM.render(<CookieNotice />, document.getElementById('cookie-notice'));

if (document.querySelector('#box-visualizer-root'))
  ReactDOM.render(
    <Visualizer />,
    document.getElementById('box-visualizer-root')
  );

if (document.querySelector('#js-storelocator-root')) {
  ReactDOM.render(
    <StoreLocator />,
    document.querySelector('#js-storelocator-root')
  );
}

if (document.querySelector('#js-custom-select'))
  ReactDOM.render(
    <CustomSelect />,
    document.getElementById('js-custom-select')
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
